<app-nav-menu></app-nav-menu>
<div>
  <ng-template #bad let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />

      <h2 class="textpopupbad"> Not Saved!</h2>
      <h5 class="textsubheadpopup"> Please Try Again!</h5>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>

    </div>


  </ng-template>
</div>
<ng-template #errormsg let-modal>

  <div class="modal-body text-center">
    <h2> You selected same calculation already!</h2>
    <h5> Removed RBD from the other calculation!</h5>
    <button class="btn-cancel btn" (click)="modal.dismiss()">Ok</button>

  </div>


</ng-template>
<div class="bodyofvoidreve" style="background-color:white;width:100%;height:100vh;">
  <div id="isFromAgencyList" style="letter-spacing:1px">
    <div style="padding: 10px; background-color: white; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; width: 100%; border-radius: 5px; ">
      <div class="row m-0 mb-2">
        <div class="col-md-12"
          style="font-weight: bold; color: var(--first-color-second); font-size: 22px; padding: 19px; letter-spacing: 2px; justify-content: center; align-items: center; display: flex; ">
          Travel Insurance Revenue Manage
        </div>
      </div>
      <div class="fadeInUp animated">
        <div class="row m-0">
          <div class="col-md-3">
            <label>Name</label>
            <input type="text" name="name" [(ngModel)]="revenueObj.name" id="name" class="main_text-box" />
            <span class="messgereq" id="messagename"></span>
          </div> <!--[(ngModel)]="revenueObj.agencyId_BranchId"-->

          <div class="col-md-3 pl-0">
            <label>Group Revenue</label>
            <ng-select #group_revenue [items]="GroupRevenue" placeholder="Group Revenue"
              bindLabel="groupName" bindValue="groupName" class="multiselect" [searchable]="true"
              [(ngModel)]="revenueObj.groupRevenueName" id="groupName" [multiple]="false"
              (change)="ChangeGroupRevenue(revenueObj.groupRevenueName)">
            </ng-select>
            <span class="messgereq" id="messageagency"></span>
          </div>

          <div class="col-md-3 pr-0 pl-0">
            <label>Agency Branch</label>
            <ng-select #agency_brancch [items]="agency_branchesList$ | async" placeholder="Agency_Branch"
              bindLabel="name" bindValue="code" class="multiselect" [ngClass]="{'read-only': isReadOnly}" [searchable]="true"
              [(ngModel)]="revenueObj.agencyBranchList" id="agencybranch" [multiple]="true"
              (change)="ChangeAgency_Branch(revenueObj.agencyBranchList)">
            </ng-select>
            <span class="messgereq" id="messageagency"></span>
          </div>
          <div class="col-md-2">
            <label>Expiry Date</label>
            <input type="date" min="{{minDate}}" name="expiryDate" id="expiryDate"
              (blur)="dateexpvalidate(revenueObj.expiryDate)" [(ngModel)]="revenueObj.expiryDate"
              class="main_text-box" />
              <span class="messgereq" id="messageexpiryDate"></span>
            </div>
            <div class="col-md-3">
              <label>Suppliers</label>
              <ng-select #supplier [items]="supplierList$ | async" placeholder="Suppliers" multiple="true"
                class="revenuedropdown multiselect newvoidrevsp" bindLabel="name" bindValue="supplierId"
                [searchable]="true" id="supplierd" [(ngModel)]="revenueObj.selectedSuppliersList"
                (change)="ChangeSupplier(revenueObj.selectedSuppliersList)">
              </ng-select>
              <span class="messgereq" id="messagesupplierd"></span>
            </div>
            <div class="col-md-2 pl-0">
              <label>Office ID</label>
              <input type="checkbox" [(ngModel)]="revenueObj.isOficeId" id="checkoffice" class="red-input"
                style="margin-left: 20px;" />

                <ng-select #oficeId [items]="oficeIdList$ | async" placeholder="Office ID" multiple="true"
                  class="revenuedropdown multiselect newvoidofice" bindLabel="officeId" bindValue="officeId"
                  [searchable]="true" [(ngModel)]="revenueObj.selectedOficeIdsList" for="ofc" id="abc">
                </ng-select>
                <span class="messgereq" id="messageisOficeId"></span>
              </div>
            </div>

            <div class="row m-0 mt-2">
              <div class="col-md-6">


                <div class="row m-0" style="font-weight: bold;">
                  <div class="col-md-4 p-0">
                    Applied On:
                  </div>
                  <div class="col-md-4 p-0 pl-3">
                    Type:
                  </div>
                  <div class="col-md-4 p-0 pl-3">
                    Applies On:
                  </div>
                </div>
                <div class="row m-0 mt-2">
                  <div class="col-md-4 p-0 ">
                    <div>
                      <input type="checkbox" [disabled]="applychilddisable" [(ngModel)]="revenueObj.applyChildAgency"
                        class="red-input" style=" max-width: 11.5%;" />
                        <label style="margin-left: 10px;">Child Agencies</label>
                      </div>
                      <div>
                        <input type="checkbox" [disabled]="applychildbranchdisable" class="red-input"
                          [(ngModel)]="revenueObj.applyChildBranches" />
                          <label style="margin-left: 10px;">Child Branches</label>
                        </div>
                        <div>
                          <input type="checkbox" class="red-input" [(ngModel)]="revenueObj.applyHO" />
                          <label style="margin-left: 10px;">HO</label>
                        </div>
                        <span class="messgereq" id="messageApplyOn"></span>
                      </div>
                      <div class="col-md-4 p-0 pl-3" style="border-left:1px solid black">
                        <div>
                          <input type="radio" name="isMarkup" [checked]="isMarkup" value="Markup"
                            (change)="ChangeType($event.target.value)" class="option-inputs radio" style=" max-width: 11.5%;" />
                            <label style="margin-left: 10px;">Markup</label>
                          </div>
                          <div>
                            <input type="radio" name="isDiscount" [checked]="isDiscount" value="Discount"
                              (change)="ChangeType($event.target.value)" class="option-inputs radio" style=" max-width: 11.5%;" />
                              <label style="margin-left: 10px;">Discount</label>
                            </div>
                            <div>
                              <input type="radio" (change)="ChangeType($event.target.value)" [checked]="isServiceFee"
                                value="ServiceFee" name="ServiceFee" class="option-inputs radio" style=" max-width: 11.5%;" />
                                <label style="margin-left: 10px;">Service Fee</label>
                              </div>
                              @if (showAirline) {
                                <div>
                                  <input type="radio" name="isAirlineCommission" [checked]="isAirlineCommission"
                                    value="AirlineCommission" (change)="ChangeType($event.target.value)" class="option-inputs radio"
                                    style=" max-width: 11.5%;" />
                                    <label style="margin-left: 10px;">Airline Commission</label>
                                  </div>
                                }
                                <span class="messgereq" id="messagetypesefe"></span>
                              </div>
                              <div class="col-md-4 p-0 pl-3" style="border-left:1px solid black">
                                <div>
                                  <input type="radio" (change)="ChangeAppliesOn($event.target.value)" [checked]="isPassenger"
                                    value="Passenger" name="isPassenger" class="option-inputs radio" style=" max-width: 11.5%;" />
                                    <label style="margin-left: 10px;">Passenger</label>
                                  </div>
                                  <!-- 05-oct-23 -->
                                  @if (showDiscountTypes) {
                                    <div>
                                      <div class="font-weight-bold">Discount Type:</div>
                                      <div>
                                        <input type="radio" [checked]="revenueObj.isDiscountSupplierCommission"
                                          (change)="OnDiscountTypeChange($event)" value="DiscountSupplierCommission" name="isDiscountType"
                                          class="option-inputs radio" style=" max-width: 11.5%;" />
                                          <label style="margin-left: 10px;">Supplier Commission</label>
                                        </div>
                                        <div>
                                          <input type="radio" [checked]="revenueObj.isRegularDiscount" (change)="OnDiscountTypeChange($event)"
                                            value="RegularDiscount" name="isDiscountType" class="option-inputs radio"
                                            style=" max-width: 11.5%;" />
                                            <label style="margin-left: 10px;">Regular Discount</label>
                                          </div>
                                          <div id="discountTypeId" class="text-danger"></div>
                                        </div>
                                      }
                                      <!-- end -->
                                      <div>
                                        <input type="radio" name="isPNR" value="PNR" [checked]="isPNR"
                                          (change)="ChangeAppliesOn($event.target.value)" class="option-inputs radio"
                                          style=" max-width: 11.5%;" />
                                          <label style="margin-left: 10px;">PNR</label>
                                        </div>
                                        <span class="messgereq" id="messageApplied"></span>
                                      </div>
                                    </div><!--style="margin-top: 31px; max-width: 11.5%; "-->

                                  </div>
                                  <div class="col-md-6">
                                    <label>Description</label>
                                    <textarea class="main_text-box" [(ngModel)]="revenueObj.description" name="remarks" id="tktRemarks"
                                    cols="120" rows="8" style="height:86px"></textarea>
                                  </div>
                                </div>
                                <hr class="dashed">
                                <div class="row justify-content-center mt-3"
                                  style="color: var(--first-color-second); font-size: 20px; letter-spacing: 2px; text-decoration: underline; font-weight: bold">
                                  Flight Calcultaion
                                </div>
                                <div class="row m-0 justify-content-end pr-4">
                                  <button class="addnewbtn" (click)="AddFlightCalculation()">
                                    <i class="fas fa-plus-circle"></i> Add New
                                  </button>

                                </div>
                                @for (dynamic of flightCalculations; track dynamic; let i = $index) {
                                  <div class="flightsdetails mt-4">
                                    <div class="row m-0">
                                      <div class="col-md-6">
                                        <label><span style="font-weight:bold;">Sr:</span> {{i+1}}</label>
                                      </div>
                                      <div class="col-md-6 ">
                                        <div class="row justify-content-end">
                                          <a class="card_button-delete" (click)="DeleteFlightCalculation(i)">
                                            <i class="uil uil-trash-alt card_button-del"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row m-0 mt-4 ">
                                      <div class="col-md-4">
                                        <label style="font-size:13px">Calculated On</label>
                                        <ng-select name="calculatedOn{{i}}" #calculatedon [items]="calculatedOnList"
                                          class="revenuedropdown multiselect newvoidrevsp" bindLabel="calculateType" bindValue="calculateType"
                                          [searchable]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="dynamic.calculatedOn">
                                        </ng-select>
                                      </div>
                                      <div class="col-md-2">
                                        <label style="font-size:13px">Value Amount</label>
                                        <input type="number" name="valueAmount{{i}}" (change)="flightvaluesamountchanges(i,dynamic.valueAmount)"
                                          class="main_text-box" id="valueAmount{{i}}" [disabled]="isPNR"
                                          [(ngModel)]="dynamic.valueAmount" />
                                          <span class="messgereq" id="messagesupplierd"></span>
                                        </div>
                                        <div class="col-md-2">
                                          <label style="font-size:13px">Value Percentage</label>
                                          <input type="number" name="valuePercent{{i}}" [disabled]="isPassenger"
                                            (change)="flightvaluespercentchanges(i,dynamic.valuePercent)" id="valuePercent{{i}}"
                                            class="main_text-box" [(ngModel)]="dynamic.valuePercent" />
                                            <span class="messgereq" id="messagesupplierd"></span>
                                          </div>
                                          <div class="col-md-2">
                                            <label style="font-size:13px">VAT</label>
                                            <input type="number" name="WTHAmount{{i}}" (change)="flightWTHamountchanges(i,dynamic.withHoldingTaxValue)"
                                              class="main_text-box" id="WTHAmount{{i}}" [(ngModel)]="dynamic.withHoldingTaxValue" />
                                            </div>
                                            <div class="col-md-2">
                                              <label style="font-size:13px">VAT Percentage</label>
                                              <input type="number" name="WTHPercent{{i}}"
                                                (change)="flightWTHpercentchanges(i,dynamic.withHoldingTaxPercentage)" id="WTHPercent{{i}}"
                                                class="main_text-box" [(ngModel)]="dynamic.withHoldingTaxPercentage" />
                                              </div>
                                              <div style="display:flex;width:100%;justify-content:end;">
                                                <span class="messgereq" style=" margin-right: 12px; margin-top: 14px;"
                                                id="valuePercentmessage{{i}}"></span>
                                              </div>
                                            </div>
                                          </div>
                                        }
                                        <div class=" row justify-content-end m-0 mt-2 pr-4">
                                          <span class="messgereq" style="font-size:18px" id="requirefldmsg"></span>
                                        </div>
                                        <!--button start-->
                                        <div class="row m-0 mt-4 mr-2" style="display: flex; justify-content: right;">
                                          <div>
                                            <button class="button-iMAGE mr-2" id="btnSave" (click)="SaveData(bad)">{{buttonName}}</button>
                                          <!--</div>
                                          <div class="col-sm-2">-->
                                            <button class="cancel_buttons" id="btnCancel" [routerLink]="['/revenueManagementList']">Cancel</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
